import { createFileRoute, redirect } from "@tanstack/react-router"
import { can } from "@/utils/can"
import { facturationMenuItems } from "@/constants/navigation"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useAuthStore } from "@/stores/useAuthStore"

export const Route = createFileRoute("/facturatie/")({
  component: RouteComponent,
  beforeLoad: async () => {
    const roles = useAuthStore.getState().user?.roles

    if (!roles || roles.length === 0) {
      throw redirect({ to: "/geen-rol", replace: true })
    }

    const firstAvailableRoute = facturationMenuItems.find((route) =>
      can("read", route.entity),
    )

    if (firstAvailableRoute) {
      throw redirect({ to: firstAvailableRoute.path, replace: true })
    }

    throw redirect({ to: "/beheer", replace: true })
  },
})

function RouteComponent() {
  return (
    <ScreenWrapper
      showManagementMenu
      managementMenuItemsFromProps={facturationMenuItems}
    />
  )
}
